import { createUseStyles, useTheme } from "react-jss";
import 'normalize.css';

const useStyles = createUseStyles(theme => ({
  "@global": {
    '*': {
      boxSizing: 'border-box'
    },
    html: {
      fontFamily: theme.typography.defaultFont,
      fontSize: "10px",
      color: theme.colors.gray.main,
    },
    a: {
      fontSize: "1.4rem",
      transition: 'all 0.25s ease-in-out',
      textDecoration: 'none',
      color: theme.colors.gray.main,
      [`@media (min-width: ${theme.breakpoints.medium.min})`]: {
        '&:hover': {
          opacity: '.5'
        }
      }
    },
    p: {
      fontSize: "1.6rem",
      lineHeight: '2.6rem',
      margin: 0
    },
    h2: {
      fontSize: '3.1rem',
      fontWeight: 'bold',
      [`@media (max-width: ${theme.breakpoints.small})`]: {
        margin: '1rem 0'
      }
    },
    'h1, h2, h3': {
      lineHeight: '1.2'
    },
    address: {
      fontStyle: 'normal'
    },
    button: {
      cursor: 'pointer'
    }
  }
}));

// Applies global CSS styles defined above using our theme
const BaseCss = () => {
  const theme = useTheme();
  useStyles({ theme });

  return null;
};

export default BaseCss;
